import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth, homeFor } from "./lib/auth";
import PublicMarketing from "./pages/PublicMarketing";
import Login, { AuthCallback } from "./pages/Login";
import PublicReport from "./pages/PublicReport";
import AppShell from "./components/AppShell";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminInspections from "./pages/admin/Inspections";
import AdminInspectionDetail from "./pages/admin/InspectionDetail";
import ReportEditor from "./pages/admin/ReportEditor";
import DefectLibrary from "./pages/admin/DefectLibrary";
import Users from "./pages/admin/Users";
import Settings from "./pages/admin/Settings";
import Roadmap from "./pages/admin/Roadmap";
import PropertyForm from "./pages/PropertyForm";
import InspectorHome from "./pages/inspector/Home";
import Inspect from "./pages/inspector/Inspect";
import Summary from "./pages/inspector/Summary";
import CustomerHome from "./pages/customer/Home";
import CustomerReport from "./pages/customer/Report";
import BuilderHome from "./pages/builder/Home";
import BuilderDetail from "./pages/builder/Detail";

function Guard({ role, children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div
        className="min-h-screen grid place-items-center overline"
        data-testid="auth-loading"
      >
        Verifying session…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role)
    return <Navigate to={homeFor(user)} replace />;
  return <AppShell>{children}</AppShell>;
}

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  const A = (el) => <Guard role="admin">{el}</Guard>;
  const I = (el) => <Guard role="inspector">{el}</Guard>;
  const C = (el) => <Guard role="customer">{el}</Guard>;
  const B = (el) => <Guard role="builder">{el}</Guard>;
  return (
    <Routes>
      <Route path="/" element={<PublicMarketing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/report/:iid" element={<PublicReport />} />
      <Route path="/admin" element={A(<AdminDashboard />)} />
      <Route path="/admin/inspections" element={A(<AdminInspections />)} />
      <Route path="/admin/inspections/new" element={A(<PropertyForm />)} />
      <Route
        path="/admin/inspections/:iid"
        element={A(<AdminInspectionDetail />)}
      />
      <Route
        path="/admin/inspections/:iid/edit-report"
        element={A(<ReportEditor />)}
      />
      <Route path="/admin/library" element={A(<DefectLibrary />)} />
      <Route path="/admin/users" element={A(<Users />)} />
      <Route path="/admin/settings" element={A(<Settings />)} />
      <Route path="/admin/roadmap" element={A(<Roadmap />)} />
      <Route path="/inspector" element={I(<InspectorHome />)} />
      <Route path="/inspector/new" element={I(<PropertyForm />)} />
      <Route path="/inspector/inspection/:iid" element={I(<Inspect />)} />
      <Route
        path="/inspector/inspection/:iid/summary"
        element={I(<Summary />)}
      />
      <Route path="/customer" element={C(<CustomerHome />)} />
      <Route path="/customer/report/:iid" element={C(<CustomerReport />)} />
      <Route path="/builder" element={B(<BuilderHome />)} />
      <Route path="/builder/inspection/:iid" element={B(<BuilderDetail />)} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}
